export default __webpack_public_path__ + "static/media/credit-limit.b1ce350b.svg";